export default "__VITE_ASSET__CAJPTHkY__"